export default __webpack_public_path__ + "static/media/KOD0144-min.ecac0f92.webp";